import React, { FC, useEffect, useRef } from 'react'
import { Heading, Link, Text } from '@chakra-ui/react'
import { useLocalization } from '@rw1/localization'
import { Layout } from '../Login/Layout'

export const LogoutSuccess: FC = () => {
  const { localize } = useLocalization()

  const urlParams = new URLSearchParams(window.location.search)
  const customProtocol = urlParams.get('customProtocol')

  const linkRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (linkRef.current && customProtocol) {
        linkRef.current.click()
      }
    }, 1500);

    return () => { clearTimeout(timer) }
  }, [])

  return (
    <Layout>
      <Heading fontSize={28}>{localize('logout.success.title')}</Heading>
      <Text>{localize('logout.success.text')}</Text>
      <Link display='none' href={customProtocol ?? undefined} ref={linkRef} />
    </Layout>
  )
}
